import React from "react";
import { Box } from "@mui/material";
import { styles } from "./styles";
import Typography from "../../../../components/Typography/Typography";
import { GREY, PRIMARY, BASE } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import MemoryScreen from "../../../Memory/MemoryScreen";
import useSummaryProgress from "../../../../hooks/useSummaryProgress";

const Security = () => {
  const classes = styles();
  const firebaseProgress = useSummaryProgress(true);

  const isActive =
    firebaseProgress.isListening &&
    firebaseProgress.state !== null &&
    !firebaseProgress.isCompleted &&
    !firebaseProgress.isFailed;

  return (
    <Box className={classes.container}>
      <Box className={classes.security}>
        <Box
          className={classes.SubHeader}
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            size={"md"}
            color={GREY.PRIMARY}
            fontWeight={fontWeight.MEDIUM}
            label="Build Your Knowledge Base"
          />
          {isActive && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "6px 14px",
                borderRadius: "999px",
                background: PRIMARY.W_50,
                border: `1px solid ${PRIMARY.W_100}`,
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: PRIMARY.W_500,
                  animation: "pulse 1.5s ease-in-out infinite",
                  "@keyframes pulse": {
                    "0%, 100%": { opacity: 1 },
                    "50%": { opacity: 0.4 },
                  },
                }}
              />
              <Typography
                size={"xs"}
                color={PRIMARY.W_700}
                fontWeight={fontWeight.SEMIBOLD}
                label={firebaseProgress.message || "Generating..."}
              />
              <Typography
                size={"xs"}
                color={PRIMARY.W_500}
                fontWeight={fontWeight.MEDIUM}
                label={`${firebaseProgress.percentage}%`}
              />
            </Box>
          )}
        </Box>
        <Box className={classes.containSecurityBoxesWidth01}>
          <MemoryScreen isSettings={true} />
        </Box>
      </Box>
    </Box>
  );
};

export default Security;
